import React from "react";
import { useSelector } from "react-redux";
import { getCustomizeCanvas } from "../../redux/creators/customizeCreators";
import "../../../../css/customize.css";
import Alignment from "../../../customizer/Alignment";
import Font from "../../../customizer/Font";
import LineHeight from "../../../customizer/LineHeight";
import Size from "../../../customizer/Size";
import Style from "../../../customizer/Style";

/**
 * Handles the customizer's extra text toolbar.
 *
 * @returns {Object}
 */
export default function TextTools() {
  const { canvas } = useSelector((state) => ({
    canvas: getCustomizeCanvas(state),
  }));

  return (
    <div className="text-controls">
      <div className="font-buttons">
        <Font view="desktop" canvas={canvas} />
      </div>
      <div className="font-buttons">
        <Size view="desktop" canvas={canvas} />
      </div>
      <div className="font-buttons">
        <Alignment canvas={canvas} />
      </div>
      <div className="font-buttons">
        <Style canvas={canvas} />
      </div>
      <div className="font-buttons">
        <LineHeight view="desktop" canvas={canvas} />
      </div>
    </div>
  );
}
